import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';
import { adaptStaff } from '../lib/adapters';

// 20-03: includeInactive opt-in for Staff & Subs Show Inactive toggle.
// Default behaviour (active-only) preserved for all other consumers.
export function useStaff(opts?: { includeInactive?: boolean }) {
  const includeInactive = opts?.includeInactive ?? false;
  return useQuery({
    queryKey: ['staff', { includeInactive }],
    // GH #173: fetch the consecutive-days streak alongside the staff list so the
    // staff card "Consec." column has a value. The backend endpoint is
    // operatives-only, so non-operatives are absent from the map and stay
    // undefined on the adapted row (rendered as "-").
    queryFn: async () => {
      const [list, consecutiveDays] = await Promise.all([
        api.staff.list({ includeInactive }),
        api.staff.consecutiveDays(),
      ]);
      return { list, consecutiveDays };
    },
    select: ({ list, consecutiveDays }) => list.map((s) => adaptStaff(s, consecutiveDays[s.id])),
    staleTime: 5 * 60 * 1000, // 5 min — staff list rarely changes
  });
}
